import React from "react";
import { Container } from "../../container";
import styles from "./thank-you.module.css";

function ThankYouPage() {
  return (
    <div className="fullHeightLayout">
      <Container>
        <h1 className={styles.title}>
          Thank You!
          <br />
          Your order is being prepared
        </h1>
      </Container>
    </div>
  );
}

ThankYouPage.propTypes = {};

export default ThankYouPage;
